import {
  bioEntitiesPerModelSelector,
  bioEntityIsContentTabOpenedSelector,
  loadingBioEntityStatusSelector,
  numberOfBioEntitiesSelector,
} from '@/redux/bioEntity/bioEntity.selectors';
import { toggleIsContentTabOpened } from '@/redux/bioEntity/bioEntity.slice';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from '@/shared/Accordion';
import { reactionsPerModelSelector } from '@/redux/reactions/reactions.selector';
import { Reaction } from '@/types/models';
import { ONE, ZERO } from '@/constants/common';
import { BioEntitiesSubmapItem } from './BioEntitiesSubmapItem';

export const BioEntitiesAccordion = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const elementsNumber = useAppSelector(numberOfBioEntitiesSelector);
  const elementsState = useAppSelector(loadingBioEntityStatusSelector);
  const elementsPerModel = useAppSelector(bioEntitiesPerModelSelector);
  const reactionsPerModel = useAppSelector(reactionsPerModelSelector);
  const isContentTabOpened = useAppSelector(bioEntityIsContentTabOpenedSelector);

  const models = [];
  for (let i = 0; i < elementsPerModel.length; i += ONE) {
    const model = elementsPerModel[i];
    let reactions: Reaction[] = [];
    for (let j = 0; j < reactionsPerModel.length; j += ONE) {
      const reactionModel = reactionsPerModel[j];
      if (reactionModel.modelId === model.modelId) {
        reactions = reactionModel.reactions;
      }
    }
    models.push({
      modelName: model.modelName,
      modelId: model.modelId,
      elements: model.bioEntities,
      numberOfBioEntities: model.numberOfEntities + reactions.length,
      reactions,
    });
  }
  for (let j = 0; j < reactionsPerModel.length; j += ONE) {
    const reactionModel = reactionsPerModel[j];
    const found = models.filter(model => model.modelId === reactionModel.modelId).length > ZERO;
    if (!found) {
      models.push({
        modelName: reactionModel.modelName,
        modelId: reactionModel.modelId,
        elements: [],
        numberOfBioEntities: reactionModel.numberOfEntities,
        reactions: reactionModel.reactions,
      });
    }
  }

  const toggleTabOpened = (): void => {
    dispatch(toggleIsContentTabOpened(!isContentTabOpened));
  };

  return (
    <AccordionItem dangerouslySetExpanded={isContentTabOpened}>
      <AccordionItemHeading>
        <AccordionItemButton onClick={toggleTabOpened}>
          Content {elementsState === 'pending' && ' (Loading...)'}
          {elementsState === 'succeeded' && ` (${elementsNumber})`}
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        {models.map(model => (
          <BioEntitiesSubmapItem
            key={model.modelName}
            mapName={model.modelName}
            mapId={model.modelId}
            numberOfEntities={model.numberOfBioEntities}
            bioEntities={model.elements}
            reactions={model.reactions}
          />
        ))}
      </AccordionItemPanel>
    </AccordionItem>
  );
};
